export default __webpack_public_path__ + "static/SR USA - GE-GMO - Statement-067dafeffafa4ad45ad05b3e2e29300b.pdf";